import { Navigate, Outlet, useRoutes } from "react-router-dom";
import { FCX, ID } from "@datassential/platform-ui-lib";
import Profile from "@pages/Profile/Profile";
import Trend from "@pages/Trend";
import Correlation from "@pages/Correlation";
import Visualize from "@pages/Visualize";
import Home from "@pages/Home";
import Test from "@pages/Test/Test";

export enum Routes {
    Home = '/',
    Profile = '/Item',
    Trend = '/Trend',
    Correlation = '/Correlation',
    Visualize = '/Visualize',
}

const routes = [
    { path: '*', element: <Navigate to={Routes.Home} /> },
    { path: Routes.Profile, element: <Profile/> },
    { path: Routes.Trend, element: <Trend/> },
    { path: Routes.Correlation, element: <Correlation/> },
    { path: Routes.Visualize, element: <Visualize/> },
    { path: Routes.Home, element: <Home/> },
    { path: "/test", element: <Test/> },
];

const Layout = () => {
    return (
        <div className="AppContent">
            <Outlet/>
        </div>
    );
};

const Router: FCX = () => {
    const routing = useRoutes([
        {
            path: '/',
            element: <Layout />,
            children: routes,
        },
    ]);

    return <>{routing}</>;
};

export default Router;

export function getKeywordProfileLink(keywordId: ID): string {
    return `${Routes.Profile}?keywordId=${keywordId}`;
}